import { IssueStatus } from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSTextArea from 'components/CIMSTextArea'
import { FormItemProps } from '../types'
import { HelpMessage } from 'utils/constants'

const DispositionNotes: React.VFC<FormItemProps> = ({ from, to }) => {
  if (
    from === IssueStatus.PendingDisposition.id ||
    from === IssueStatus.PendingResponse.id
  )
    return null
  return (
    <CIMSFormItem
      help={HelpMessage.Issues.IssueTracker.DispositionNotes}
      name="dispositionNotes"
      label="Disposition Notes"
      requiredMessage={to === IssueStatus.PendingClosure.id ? true : undefined}
    >
      <CIMSTextArea maxLength={2000} />
    </CIMSFormItem>
  )
}

export default DispositionNotes
